import { Facebook, Instagram, Twitter, Youtube } from "lucide-react";
import { Link } from "react-router-dom";

export function Footer() {
	const currentYear = new Date().getFullYear();

	const footerLinks = [
		{
			title: "Starch",
			links: [
				{ name: "About Us", href: "/about" },
				{ name: "Press", href: "/press" },
				{ name: "Careers", href: "/careers" },
			],
		},
		{
			title: "For Retailers",
			links: [
				{ name: "Browse Products", href: "/products" },
				{ name: "Find Suppliers", href: "/suppliers" },
			],
		},
		{
			title: "For Suppliers",
			links: [
				{ name: "Sell on Starch", href: "/suppliers/sell" },
				{ name: "Supplier Portal", href: "/suppliers/portal" },
				{
					name: "Brand Guidelines",
					href: "/suppliers/brand-guidelines",
				},
				{ name: "Supplier FAQ", href: "/suppliers/faq" },
			],
		},
		{
			title: "Resources",
			links: [
				{ name: "Blog", href: "/blog" },
				{ name: "Guides", href: "/guides" },
				{ name: "Support", href: "/support" },
				{ name: "Terms of Service", href: "/terms" },
				{ name: "Privacy Policy", href: "/privacy" },
			],
		},
	];

	return (
		<footer className="bg-gray-50 border-t border-gray-100">
			<div className="mx-auto max-w-7xl px-6 md:px-12">
				{/* <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
					{footerLinks.map((section) => (
						<div key={section.title} className="space-y-4">
							<h4 className="text-sm font-semibold text-gray-900">
								{section.title}
							</h4>
							<ul className="space-y-3">
								{section.links.map((link) => (
									<li key={link.name}>
										<Link
											to={link.href}
											className="text-sm text-gray-600 hover:text-gray-900 transition-all duration-200">
											{link.name}
										</Link>
									</li>
								))}
							</ul>
						</div>
					))}
				</div> */}

				<div className="mt-12 py-12 border-t border-gray-200">
					<div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
						<div>
							<Link
								to="/"
								className="text-lg font-display font-semibold tracking-tight text-accent">
								Starch
							</Link>
							<p className="mt-2 text-sm text-gray-500">
								The wholesale marketplace connecting retailers
								and suppliers.
							</p>
						</div>

						<div className="flex space-x-4">
							<a
								href="#"
								className="text-gray-400 hover:text-accent transition-all duration-200"
								aria-label="Facebook">
								<Facebook className="h-5 w-5" />
							</a>
							<a
								href="#"
								className="text-gray-400 hover:text-accent transition-all duration-200"
								aria-label="Instagram">
								<Instagram className="h-5 w-5" />
							</a>
							<a
								href="#"
								className="text-gray-400 hover:text-accent transition-all duration-200"
								aria-label="Twitter">
								<Twitter className="h-5 w-5" />
							</a>
							<a
								href="#"
								className="text-gray-400 hover:text-accent transition-all duration-200"
								aria-label="Youtube">
								<Youtube className="h-5 w-5" />
							</a>
						</div>
					</div>

					<div className="mt-8 text-sm text-gray-500">
						<p>© {currentYear} Starch. All rights reserved.</p>
					</div>
				</div>
			</div>
		</footer>
	);
}
